import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface TokenCheckProviderProps {
    children: React.ReactNode
}

const getCookie = (name: string) => {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.startsWith(name + "=")) {
            return cookie.split("=")[1];
        }
    }
    return null;
};

const decodeJwt = (token: string): any | null => {
    try {
        const base64Url = token.split(".")[1];
        if (!base64Url) return null;
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split("")
                .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
                .join("")
        );
        return JSON.parse(jsonPayload);
    } catch (err) {
        console.error("Error decoding token:", err);
        return null;
    }
};

const TokenCheckProvider: React.FC<TokenCheckProviderProps> = ({ children }) => {
    const navigate = useNavigate();
    useEffect(() => {
        const checkTokenValidity = () => {
            const token = getCookie("accessToken");
            if(!token) return;

            const decoded = decodeJwt(token);
            if(!decoded || !decoded.exp) return;

            const currentTime = Math.floor(Date.now() / 1000);

            if(decoded.exp < currentTime) {
                document.cookie = "accessToken=; Max-Age=0; path=/;";
                window.dispatchEvent(new Event("tokenExpired"));
            }
        };

        checkTokenValidity();

        const interval = setInterval(checkTokenValidity, 30 * 60 * 1000);

        return () => clearInterval(interval);
    }, [navigate]);

    return <>{children}</>
}

export default TokenCheckProvider